// extracted by mini-css-extract-plugin
export var aircallIframe = "_f8-3";
export var fabContainer = "_f8-5";
export var fabRinging = "_f8-6";
export var loadingOverlay = "_f8-4";
export var pulse = "_f8-7";
export var widgetContent = "_f8-2";
export var widgetPanel = "_f8-0";
export var widgetPanelExpanded = "_f8-1";